import * as moment from 'moment';
import Moment = moment.Moment;
import 'moment/locale/da';

export class Notification {

    static _JSONProps: string[] = [
        'shipment_id',
        'id',
        'user_id',
        'title',
        'message',
        'is_read',
        'is_sent',
    ];

    id: string;
    shipment_id: string;
    user_id: number;
    title: string;
    message: string;
    is_read: boolean;
    is_sent: boolean;
    created: Moment;
    modified: Moment;

    static fromJSON(json: NotificationJSON | string): Notification {
        if (json === null) {
            return new Notification();
        }

        if (typeof json === 'string') {
            return JSON.parse(json, Notification.reviver);
        } else {
            const notification = Object.create(Notification.prototype);

            const extra = {
                modified: json.modified ? moment(json.modified) : null,
                created: json.created ? moment(json.created) : null
            };

            Object.keys(json).forEach((key, index) => {
                if (Notification._JSONProps.indexOf(key) !== -1) {
                    notification[key] = json[key];
                }
            });

            return Object.assign(notification, extra);
        }
    }

    static reviver(key: string, value: any): any {
        return key === '' ? Notification.fromJSON(value) : value;
    }

    constructor(initializer?: NotificationJSON) {
        if (initializer === undefined) {
            return;
        }
    }
}

// A representation of Token data that can be converted to
// and from JSON without being altered.
export interface NotificationJSON {
    id?: string;
    user_id?: number;
    title?: string;
    message?: string;
    is_read?: boolean;
    created?: string;
    modified?: string;
}
